import React from 'react';
import ExpandIcon from '@/public/icons/approval/expand.svg';
import { ZoomImageWrap, ZoomExpandIcon } from './styles';

type ZoomableImageProps = {
  src: string; // 원본 이미지 URL. `useContentHtmlPostprocess` 가 img 태그 src 로부터 추출해 전달 예정. (클릭 시 onZoom 으로 전달)
  alt?: string;
  imgProps?: React.ImgHTMLAttributes<HTMLImageElement>; // 파서가 매핑한 나머지 img 속성(className/style 등)
  align?: string; // 이미지 정렬(data-format: center/right). wrapper 에 적용해야 실제로 정렬됨.
  onZoom: (src: string) => void; // 확대(크게보기) 트리거. wrapper 클릭 시 src 로 호출
};

// 정렬은 inline-block wrapper 를 block+fit-content 로 만들고 margin auto 로 가운데/우측 이동(작성화면 ImageNode.createDOM 과 동일 방식).
const wrapAlignStyle = (align?: string): React.CSSProperties | undefined => {
  if (align === 'center') {
    return { display: 'block', width: 'fit-content', margin: '0 auto' };
  }
  if (align === 'right') {
    return { display: 'block', width: 'fit-content', marginLeft: 'auto' };
  }
  return undefined;
};

/**
 * 본문 인라인 이미지 + 우하단 "크게보기" 확대 아이콘.
 * 아이콘은 pointer-events:none 라 클릭이 wrapper 로 전달, hover 는 CSS 담당(JS 핸들러 없음).
 */
const ZoomableImage = ({
  src,
  alt,
  imgProps,
  align,
  onZoom,
}: ZoomableImageProps) => {
  return (
    <ZoomImageWrap style={wrapAlignStyle(align)} onClick={() => onZoom(src)}>
      {/* imgProps 의 src/alt 보다 명시 prop 우선 (파서가 src 를 imgProps 에 담아도 동일값) */}
      <img {...imgProps} src={src} alt={alt ?? imgProps?.alt ?? ''} />
      <ZoomExpandIcon className="expand-icon" aria-hidden="true">
        <ExpandIcon />
      </ZoomExpandIcon>
    </ZoomImageWrap>
  );
};

export default ZoomableImage;
